export default __webpack_public_path__ + "static/7_34-f802e5cd9cf95ae1cb861d2ed746c3fe.png";